import {
  Shop,
  ProductType,
  TipsterInfo,
  ShopProduct,
} from '../shared/interfaces';

import { TipProduct } from './interfaces/TipProduct';

export class TipShop implements Shop {
  type: ProductType = 'TIP';
  products: TipProduct[];
  tipsterInfo: TipsterInfo;
  selectedProduct: ShopProduct;

  constructor(products: TipProduct[], tipsterInfo: TipsterInfo) {
    this.products = products;
    this.selectedProduct = products[0];
    this.tipsterInfo = tipsterInfo;
  }
}
